<!--Start Back To Top Button-->
<a href="javaScript:;" class="back-to-top"><i class="fa fa-angle-double-up"></i> </a>
<!--End Back To Top Button-->

<!--Start footer-->
<footer class="footer position-fixed">
  <div class="container">
    <div class="text-center">
      Copyright © {{yearFull}} Agnext
    </div>
  </div>
</footer>
<!--End footer-->